import { render, staticRenderFns } from "./deskSession.vue?vue&type=template&id=68efab56&"
import script from "./deskSession.vue?vue&type=script&lang=js&"
export * from "./deskSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports